import { SUCCESS } from "components/constants";
import { useState } from "react";
import { toCurrency } from "utils/helpers";
import { PENDING } from "utils/helpers/constants";
import StatusPill from "utils/pills/StatusPill/StatusPill";
import Table from "utils/Table/Table";
import BankingWalletFilters from "../../common/BankingWalletFilters";
import CardInfoModal from "../../common/modals/CardInfoModal";
import {
	CardsTableHeadings,
	bankingWalletsTableData,
	bankingWalletsFiltersDefaultValues,
} from "../../helpers/data";

const CardTable = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [currentRowValues, setCurrentRowValues] = useState({});
	const [formValues, setFormValues] = useState({
		...bankingWalletsFiltersDefaultValues,
	});

	const handleChange = ({ target: { name, value } }) =>
		handleSelect(name, value);

	const handleSelect = (name, value) => {
		console.log({ name, value });
		setFormValues((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const toggleModal = () => setIsOpen((prev) => !prev);

	const handleSubmit = () =>
		setFormValues({ ...bankingWalletsFiltersDefaultValues });

	const getWalletData = () =>
		bankingWalletsTableData?.map((transaction) => ({
			walletId: transaction?.walletId,
			amount: `₦ ${toCurrency(transaction?.balance)}`,
			cardType: "Card",
			channel: `₦ ${toCurrency(transaction?.balance)}`,
			status: (
				<StatusPill
					status="Success"
					success={SUCCESS}
					warning={PENDING}
				/>
			),
			createdAt: transaction?.createdAt,
		}));

	const handleRowClick = (_, rowValues) => {
		const transactionData = bankingWalletsTableData?.find(
			(transaction) => transaction?.reference === rowValues?.transactionID
		);
		setCurrentRowValues({
			...rowValues,
			...transactionData,
		});
		toggleModal();
	};
	return (
		<>
			<BankingWalletFilters
				formValues={formValues}
				handleChange={handleChange}
				handleSubmit={handleSubmit}
				handleSelect={handleSelect}
			/>
			<Table
				data={getWalletData()}
				headings={CardsTableHeadings}
				rowClick={handleRowClick}
			/>
			{isOpen && (
				<CardInfoModal
					toggle={toggleModal}
					payment={currentRowValues}
					IDTabName={`Transaction Information`}
				/>
			)}
		</>
	);
};

export default CardTable;
